/**
 * @flow
 * @relayHash fec9b82341bb93a7a96a6ce8a8c26db3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateSavedAreaFromGeographicEntityInput = {
  value: string,
  label: string,
  geographicUnit: string,
  clientMutationId?: ?string,
};
export type MapRoomEmbedRootCreateAreaMutationVariables = {|
  input: CreateSavedAreaFromGeographicEntityInput
|};
export type MapRoomEmbedRootCreateAreaMutationResponse = {|
  +createSavedAreaFromGeographicEntity: ?{|
    +savedAreaNode: ?{|
      +id: string
    |}
  |}
|};
export type MapRoomEmbedRootCreateAreaMutation = {|
  variables: MapRoomEmbedRootCreateAreaMutationVariables,
  response: MapRoomEmbedRootCreateAreaMutationResponse,
|};
*/


/*
mutation MapRoomEmbedRootCreateAreaMutation(
  $input: CreateSavedAreaFromGeographicEntityInput!
) {
  createSavedAreaFromGeographicEntity(input: $input) {
    savedAreaNode {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSavedAreaFromGeographicEntityInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createSavedAreaFromGeographicEntity",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateSavedAreaFromGeographicEntityInput!"
      }
    ],
    "concreteType": "CreateSavedAreaFromGeographicEntityPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "savedAreaNode",
        "storageKey": null,
        "args": null,
        "concreteType": "SavedAreaNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "MapRoomEmbedRootCreateAreaMutation",
  "id": null,
  "text": "mutation MapRoomEmbedRootCreateAreaMutation(\n  $input: CreateSavedAreaFromGeographicEntityInput!\n) {\n  createSavedAreaFromGeographicEntity(input: $input) {\n    savedAreaNode {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MapRoomEmbedRootCreateAreaMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "MapRoomEmbedRootCreateAreaMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f79d18bfdc2b147946e3fdca7e2dd719';
module.exports = node;



// WEBPACK FOOTER //
// ./src/components/Root/__generated__/MapRoomEmbedRootCreateAreaMutation.graphql.js